import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import RevokeRegistryUserDialog from '../RevokeRegistryUserDialog/RevokeRegistryUserDialog';
import { useState } from 'react';
import RevokeUserIcon from 'icons/RevokeUserIcon';
import { ERegistryStatus } from 'enum/ERegistryStatus';

interface Props {
  item: any;
  refetch?: () => void;
}

export default function RegistryUserItemOptions({ item, refetch }: Props) {
  const globalStyles = useGlobalStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [revokeOpen, setRevokeOpen] = useState<boolean>(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleRevokeClick = () => {
    handleClose();
    setRevokeOpen(true);
    console.log('hello', item);
  }
  return (
    <div>

      <IconButton
        onClick={handleClick}
        className={globalStyles.p0}
        disableRipple
      >
        <MoreVertIcon sx={{ color: colors.secondary }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '200px'
          }}
          p={1}
        >
          <IconButton
            onClick={handleRevokeClick}
            className={globalStyles.popoverButtonContainer}
          >
            <Box className={globalStyles.popoverIconContainer}>
              <RevokeUserIcon size={18} />
            </Box>
            <CustomText text={item.status == ERegistryStatus.PENDING ? 'Cancel Invitation' : 'Revoke Access'} ml="5px" color={colors.black} />
          </IconButton>

        </Box>
      </Popover>

      <RevokeRegistryUserDialog
        open={revokeOpen}
        setOpen={setRevokeOpen}
        endUser={item}
        refetch={refetch}
      />

    </div>
  );
}
